// extracted by mini-css-extract-plugin
module.exports = {"article":"styles_article__1ucbE","goBack":"styles_goBack__3yd8T","header":"styles_header__2H5hn","details":"styles_details__3heY1","articleContent":"styles_articleContent__26MUI"};